
import { Candidate } from "../../candidates/types";

interface CandidateInfoProps {
  candidate: Candidate;
}

export function CandidateInfo({ candidate }: CandidateInfoProps) {
  return (
    <div className="border rounded-md p-4 mb-4">
      <h3 className="text-lg font-medium">Candidate Information</h3>
      <div className="grid grid-cols-2 gap-4 mt-2">
        <div>
          <h4 className="text-sm font-medium text-muted-foreground">Name</h4>
          <p className="text-sm">{candidate.first_name} {candidate.last_name}</p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-muted-foreground">Email</h4>
          <p className="text-sm">{candidate.email}</p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-muted-foreground">Phone</h4>
          <p className="text-sm">{candidate.phone || 'N/A'}</p>
        </div>
        <div>
          <h4 className="text-sm font-medium text-muted-foreground">Current Role</h4>
          <p className="text-sm">{candidate.current_role || 'N/A'}</p>
        </div>
      </div>
    </div>
  );
}
